import { FunctionComponent } from 'react';
import App from './App';

const Nordsjo: FunctionComponent = () => {
  return (
    <div id="calculator-app" className="App nordsjo-app">
      <App customer="nordsjo" />
    </div>
  );
};

export default Nordsjo;
